export class DataQualityAlertRouting {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "critical",
            "baseName": "critical",
            "type": "AlertChannel",
            "format": ""
        },
        {
            "name": "warning",
            "baseName": "warning",
            "type": "AlertChannel",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DataQualityAlertRouting.attributeTypeMap;
    }
    constructor() {
    }
}
